export default __webpack_public_path__ + "static/media/infrastructureBg.6eb1d793.jpg";